<template>
  <v-container class="results-list-container">
    <h2>
      We've found {{ this.matches.length }} lenders that match your criteria!
    </h2>

    <lender-card-layout
      v-for="(match, index) in matches"
      :key="index">

      <template #logo v-if="match.product.logo" >
        <div class="boxed-image standout">
          <img :src="match.product.logo" />
        </div>
      </template>

      <template #score>
        <template v-if="$vuetify.breakpoint.lgAndUp">
          <p>Customer Reviews</p>
          <h1>
            {{ (match.product.scoreAverage && match.product.scoreAverage.toFixed(2)) || 0 }}
          </h1>
          <p class="subdued">average score</p>
          <star-rating
            :rating="match.product.scoreAverage"
            :editable="false"
            :count="match.product.reviewCount || 0"
          ></star-rating>
        </template>

        <template v-if="$vuetify.breakpoint.mdAndDown">
          <star-rating
            :rating="match.product.scoreAverage"
            :editable="false"
          ></star-rating>
        </template>
      </template>

      <template #description>
        {{ match.product.description }}

        <div v-if="match.product.discount" class="discount">
          <img :src="discountIcon" />
          <label>LendingWell Benefit</label>
          <span>{{ match.product.discount }}</span>
        </div>
      </template>

      <template #disclaimer>
        *Selecting "email lender" will send an email to lenders with your contact information and loan request details
      </template>

      <template #contactButton>
        <button
          v-if="!match.product.contactedAt"
          :disabled="emailingLender"
          class="default-btn blue"
          @click="emailLender(index)"
        >Email Lender</button>

        <button
          v-else disabled
          class="default-btn green"
        ><span class="mdi mdi-check"></span> Contacted</button>
      </template>

      <template #infoButton>
        <router-link
          class="default-btn"
          :class="[$vuetify.breakpoint.mdAndUp ? 'text' : 'blue inverse']"
          :to="{ name: 'Lender', params: { productId: match.product.id }}"
        >View Lender Details »</router-link>
      </template>
    </lender-card-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import DiscountIcon from '@/modules/shared/assets/discount_icon.png'
import LenderCardLayout from './LenderCardLayout'

export default {
  name: 'ResultsList',
  components: {
    LenderCardLayout,
  },
  props: {
    dealId: String,
    matches: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    emailingLender: false,
    discountIcon: DiscountIcon,
  }),
  computed: {
    ...mapGetters('feathers', ['apiMatches']),
  },
  methods: {
    async emailLender (index) {
      this.emailingLender = true

      try {
        await this.apiMatches.patch(this.matches[index].id, {
          contactedAt: Date.now(),
        })

        this.matches[index].contactedAt = Date.now()

        this.addAlert({
          type: 'success',
          message: 'Successfully sent a contact email!',
        })
      } catch (err) {
        this.addAlert({
          type: 'error',
          message: `There was an issue when attempting to contact lender: ${err.message}`,
        })
      }

      this.emailingLender = false
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 35px;

  color: $textDarkMuted;
  text-align: center;

  @include md {
    margin-bottom: 65px;
  }

  @include lg {
    text-align: left;
  }
}

.results-list-container {
  padding-bottom: 100px;
}

.match-item-wrapper {
  & > *:last-child {
    padding-left: 64px;

    display: flex;
    flex-direction: column;

    & > div {
      margin-top: 28px;

      display: flex;
      justify-content: flex-start;
    }
  }
}

.boxed-image {
  margin: -25px auto 0 auto;

  @include lg {
    margin-top: 30px;
    margin-bottom: 15px;
  }
}
</style>
